<template>
	<div>
		<pui-modal-dialog-form
			:titleText="$t('cargo.requestClearanceAction')"
			:modelName="modelName"
			:dialogName="dialogNameRequestClearance"
			:widthDialog="800"
			:onOk="onOkActionsRequestRejectConfirmAndReject"
			:onShow="onShowRequestClearance"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-field-set :title="$t('cargo.operation')">
							<v-layout wrap style="margin-top: 15px; margin-bottom: 15px">
								<v-flex xs12 md12 lg3 x3
									><pui-checkbox
										:id="`checkbox-unloading-${modelName}`"
										:label="$t('cargo.unloading')"
										v-model="checkboxGroup.unloading"
										true-value="true"
										false-value="false"
										:disabled="unloadingDisabled"
									></pui-checkbox
								></v-flex>
								<v-flex xs12 md12 lg3 x3
									><pui-checkbox
										:id="`checkbox-loading-${modelName}`"
										:label="$t('cargo.loading')"
										v-model="checkboxGroup.loading"
										true-value="true"
										false-value="false"
										:disabled="loadingDisabled"
									></pui-checkbox
								></v-flex>
							</v-layout>
						</pui-field-set>
						<v-flex xs12 md12 style="margin-top: 15px">
							<pui-text-area
								:id="`cargo-observations`"
								v-model="data.modalData.remarks"
								:label="$t('cargo.requestclearancetextbox')"
								toplabel
								maxlength="256"
							></pui-text-area
						></v-flex>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('cargo.rejectDocumentation')"
			:modelName="modelName"
			:dialogName="dialogNameRejectDocumentation"
			:widthDialog="800"
			:onOk="onOkActionsRequestRejectConfirmAndReject"
			:onShow="onShowRejectDocumentation"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-field-set :title="$t('cargo.operation')">
							<v-layout wrap style="margin-top: 15px; margin-bottom: 15px">
								<v-flex xs12 md12 lg3 x3
									><pui-checkbox
										:id="`checkbox-unloading-${modelName}`"
										:label="$t('cargo.unloading')"
										v-model="checkboxGroup.unloading"
										true-value="true"
										false-value="false"
										:disabled="unloadingDisabled"
									></pui-checkbox
								></v-flex>
								<v-flex xs12 md12 lg3 x3
									><pui-checkbox
										:id="`checkbox-loading-${modelName}`"
										:label="$t('cargo.loading')"
										v-model="checkboxGroup.loading"
										true-value="true"
										false-value="false"
										:disabled="loadingDisabled"
									></pui-checkbox
								></v-flex>
							</v-layout>
						</pui-field-set>
						<v-flex xs12 md12 style="margin-top: 15px">
							<pui-text-area
								:id="`cargo-rejectdocumenttextbox`"
								v-model="data.modalData.remarks"
								:label="$t('cargo.rejectdocumenttextbox')"
								toplabel
								maxlength="256"
							></pui-text-area
						></v-flex>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('cargo.confirmClearance')"
			:modelName="modelName"
			:dialogName="dialogNameConfirmClearance"
			:widthDialog="800"
			:onOk="onOkActionsRequestRejectConfirmAndReject"
			:onShow="onShowConfirmClearance"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-field-set :title="$t('cargo.operation')">
							<v-layout wrap style="margin-top: 15px; margin-bottom: 15px">
								<v-flex xs12 md12 lg3 x3
									><pui-checkbox
										:id="`checkbox-unloading-${modelName}`"
										:label="$t('cargo.unloading')"
										v-model="checkboxGroup.unloading"
										true-value="true"
										false-value="false"
										:disabled="unloadingDisabled"
									></pui-checkbox
								></v-flex>
								<v-flex xs12 md12 lg3 x3
									><pui-checkbox
										:id="`checkbox-loading-${modelName}`"
										:label="$t('cargo.loading')"
										v-model="checkboxGroup.loading"
										true-value="true"
										false-value="false"
										:disabled="loadingDisabled"
									></pui-checkbox
								></v-flex>
							</v-layout>
						</pui-field-set>
						<v-layout wrap style="margin-top: 15px">
							<v-col class="pt-6" cols="5">
								<label>{{ $t('cargo.selectcodes') }}</label>
							</v-col>
							<v-col class="pt-6" cols="3">
								<pui-select
									:id="`selectyesno-cargo`"
									v-model="selectedYesNo"
									:modelFormMapping="{ valor: 'value' }"
									reactive
									leftlabel
									modelName="vlupyesnoquestions"
									:itemsToSelect="[{ valor: selectedYesNo.value }]"
									:itemValue="['valor']"
									:itemText="(item) => `${item.opcion}`"
								></pui-select>
							</v-col>
						</v-layout>

						<v-flex xs12 md12>
							<pui-text-area
								:id="`cargo-confirmclearancetextbox`"
								v-model="data.modalData.remarks"
								:label="$t('cargo.confirmclearancetextbox')"
								toplabel
								maxlength="256"
							></pui-text-area
						></v-flex>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('cargo.rejectClearance')"
			:modelName="modelName"
			:dialogName="dialogNamerejectClearance"
			:widthDialog="800"
			:onOk="onOkActionsRequestRejectConfirmAndReject"
			:onShow="onShowrejectClearance"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-field-set :title="$t('cargo.operation')">
							<v-layout wrap style="margin-top: 15px; margin-bottom: 15px">
								<v-flex xs12 md12 lg3 x3
									><pui-checkbox
										:id="`checkbox-unloading-${modelName}`"
										:label="$t('cargo.unloading')"
										v-model="checkboxGroup.unloading"
										true-value="true"
										false-value="false"
										:disabled="unloadingDisabled"
									></pui-checkbox
								></v-flex>
								<v-flex xs12 md12 lg3 x3
									><pui-checkbox
										:id="`checkbox-loading-${modelName}`"
										:label="$t('cargo.loading')"
										v-model="checkboxGroup.loading"
										true-value="true"
										false-value="false"
										:disabled="loadingDisabled"
									></pui-checkbox
								></v-flex>
							</v-layout>
						</pui-field-set>
						<v-flex xs12 md12 style="margin-top: 15px">
							<pui-text-area
								:id="`cargo-rejectClearancetextbox`"
								v-model="data.modalData.remarks"
								:label="$t('cargo.rejectClearancetextbox')"
								toplabel
								required
								maxlength="256"
							></pui-text-area
						></v-flex>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('cargo.undoRejectClearance')"
			:modelName="modelName"
			:dialogName="dialognameUndoRejectClearance"
			:widthDialog="800"
			:onOk="onOkActionsRequestRejectConfirmAndReject"
			:onShow="onShowundoRejectClearance"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-field-set :title="$t('cargo.operation')">
							<v-layout wrap style="margin-top: 15px; margin-bottom: 15px">
								<v-flex xs12 md12 lg3 x3
									><pui-checkbox
										:id="`checkbox-unloading-${modelName}`"
										:label="$t('cargo.unloading')"
										v-model="checkboxGroup.unloading"
										true-value="true"
										false-value="false"
										:disabled="unloadingDisabled"
									></pui-checkbox
								></v-flex>
								<v-flex xs12 md12 lg3 x3
									><pui-checkbox
										:id="`checkbox-loading-${modelName}`"
										:label="$t('cargo.loading')"
										v-model="checkboxGroup.loading"
										true-value="true"
										false-value="false"
										:disabled="loadingDisabled"
									></pui-checkbox
								></v-flex>
							</v-layout>
						</pui-field-set>
						<v-flex xs12 md12 style="margin-top: 15px">
							<pui-text-area
								:id="`cargo-rejectClearancetextbox`"
								v-model="data.modalData.remarks"
								:label="$t('cargo.rejectClearancetextbox')"
								toplabel
								maxlength="256"
							></pui-text-area
						></v-flex>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('puiaction.audit')"
			:modelName="modelName"
			disableCancel
			:okText="$t('Close')"
			:dialogName="dialogNamepuiAuditCargo"
			@input="onAuditModalChange"
		>
			<template slot="message" slot-scope="data" :widthDialog="1820">
				<v-layout wrap class="justify-center">
					<div class="puiAuditFormtable">
						<!-- GRID PRINCIPAL -->
						<div class="audit-grid">
							<table>
								<thead>
									<tr>
										<th>{{ $t('puiauditExtended.datetime') }}</th>
										<th>{{ $t('puiauditExtended.type') }}</th>
										<th>{{ $t('puiauditExtended.nameAgency') }}</th>
										<th>{{ $t('puiauditExtended.vat') }}</th>
										<th>{{ $t('puiauditExtended.address') }}</th>
										<th>{{ $t('puiauditExtended.idnumber') }}</th>
										<th>{{ $t('puiauditExtended.user') }}</th>
										<th>{{ $t('puiauditExtended.email') }}</th>
										<th>{{ $t('puiauditExtended.phone') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(record, idx) in data.modalData"
										:key="record.id || idx"
										@click="onSelectRecord(record)"
										:class="{ selected: selectedRecord && selectedRecord.id === record.id }"
									>
										<td>{{ formatDate(record.datetime) }}</td>
										<td>{{ record.type }}</td>
										<td>{{ record.descripcion }}</td>
										<td>{{ record.documento }}</td>
										<td>{{ record.direccion }}</td>
										<td>{{ record.idnumber }}</td>
										<td>{{ record.username }}</td>
										<td>{{ record.email }}</td>
										<td>{{ record.telefono }}</td>
									</tr>
								</tbody>
							</table>
						</div>

						<!-- DETALLE DEL REGISTRO SELECCIONADO -->
						<div class="audit-details">
							<table>
								<thead>
									<tr>
										<th>{{ $t('puiaudit.attribute') }}</th>
										<th
											v-if="
												selectedRecord &&
												selectedRecord.type === 'update' &&
												selectedRecord.type === 'insert' &&
												selectedRecord.type === 'cargo'
											"
										>
											{{ $t('puiaudit.oldValue') }}
										</th>
										<th>{{ $t('puiaudit.newValue') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in content" :key="index">
										<td>
											<span>{{ item.attribute }}</span>
										</td>
										<template v-if="selectedRecord && selectedRecord.type === 'update'">
											<td v-if="item.oldValue && Array.isArray(item.oldValue)">
												<tr v-for="(internalItem, internalIndex) in item.oldValue" :key="internalIndex">
													<pui-audit-item :model="internalItem"></pui-audit-item>
												</tr>
											</td>
											<pui-audit-item v-else :model="item.oldValue"></pui-audit-item>
										</template>
										<td v-if="item.value && Array.isArray(item.value)">
											<tr v-for="(internalItem, internalIndex) in item.value" :key="internalIndex">
												<pui-audit-item :model="internalItem"></pui-audit-item>
											</tr>
										</td>
										<pui-audit-item v-else :model="item.value"></pui-audit-item>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
	</div>
</template>

<script>
import PuiAuditItem from 'pui9-datatables/src/components/puiaudit/PuiAuditItem.vue';
export default {
	name: 'georepreport-modals',
	components: {
		PuiAuditItem
	},
	data() {
		return {
			dialogNameRequestClearance: 'requestClearance',
			dialogNameRejectDocumentation: 'rejectDocumentation',
			dialogNameConfirmClearance: 'confirmClearance',
			dialogNamerejectClearance: 'rejectClearance',
			dialognameConfirmRejectClearance: 'confirmrejectclearance',
			dialognameUndoRejectClearance: 'undoRejectClearance',
			dialogNamepuiAuditCargo: 'viewAuditCargo',
			checkboxGroup: {
				loading: false,
				unloading: false
			},
			actionClearance: false,
			actionRejectDoc: false,
			actionConfirmClearance: false,
			actionRejectClearance: false,
			actionUndoRejectClearance: false,
			loadingDisabled: false,
			unloadingDisabled: false,
			selectedYesNo: {
				value: 0
			},
			type: 'insert',
			content: [],
			selectedRecord: null
		};
	},
	props: {
		modelName: {
			required: true,
			type: String
		}
	},
	methods: {
		onShowRequestClearance(modalData) {
			this.actionRejectDoc = false;
			this.actionClearance = true;
			this.actionConfirmClearance = false;
			this.actionRejectClearance = false;
			this.selectedYesNo.value = null;
			this.disableCheckbox(modalData, 1);
		},
		onShowRejectDocumentation(modalData) {
			this.actionRejectDoc = true;
			this.actionClearance = false;
			this.actionConfirmClearance = false;
			this.actionRejectClearance = false;
			this.selectedYesNo.value = null;
			this.disableCheckbox(modalData, 2);
		},
		onShowConfirmClearance(modalData) {
			this.actionRejectDoc = false;
			this.actionClearance = false;
			this.actionConfirmClearance = true;
			this.actionRejectClearance = false;
			this.selectedYesNo.value = null;
			this.disableCheckbox(modalData, 3);
		},
		onShowrejectClearance(modalData) {
			this.actionRejectDoc = false;
			this.actionClearance = false;
			this.actionConfirmClearance = false;
			this.actionRejectClearance = true;
			this.selectedYesNo.value = null;
			this.disableCheckbox(modalData, 4);
		},
		onShowundoRejectClearance(modalData) {
			this.actionRejectDoc = false;
			this.actionClearance = false;
			this.actionConfirmClearance = false;
			this.actionRejectClearance = false;
			this.actionUndoRejectClearance = true;
			this.selectedYesNo.value = null;
			this.disableCheckbox(modalData, 5);
		},
		onOkActionsRequestRejectConfirmAndReject(modalData) {
			if (this.checkboxGroup.loading == 'false' || this.checkboxGroup.loading == false) this.checkboxGroup.loading = false;
			if (this.checkboxGroup.unloading == 'false' || this.checkboxGroup.unloading == false) this.checkboxGroup.unloading = false;

			if (!this.checkboxGroup.loading && !this.checkboxGroup.unloading) {
				this.$puiNotify.error(this.$puiI18n.t('cargo.checkboxerror'), this.$puiI18n.t('cargo.checkboxtitleerror'));
			} else {
				return new Promise((resolve) => {
					this.$puiRequests.getRequest(
						this.$store.getters.getModelByName('cargo').url.actionsRequestAndReject,
						{
							model: this.modelName,
							cargoclearanceid: modalData.headerPk.cargoclearanceid,
							checkloading: this.checkboxGroup.loading,
							checkunloading: this.checkboxGroup.unloading,
							remarks: modalData.remarks,
							actionRequest: this.actionClearance,
							actionReject: this.actionRejectDoc,
							actionConfirmClearance: this.actionConfirmClearance,
							actionRejectClearance: this.actionRejectClearance,
							actionUndoRejectClearance: this.actionUndoRejectClearance,
							selectYesNo: this.selectedYesNo.value
						},
						() => {
							this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
							this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelName);
							if (this.actionClearance)
								this.$puiNotify.success(this.$puiI18n.t('puiaction.notifySuccess'), this.$puiI18n.t('cargo.requestClearanceAction'));
							if (this.actionRejectDoc)
								this.$puiNotify.success(
									this.$puiI18n.t('puiaction.notifySuccess'),
									this.$puiI18n.t('cargo.rejectDocumentationAction')
								);
							if (this.actionConfirmClearance)
								this.$puiNotify.success(this.$puiI18n.t('puiaction.notifySuccess'), this.$puiI18n.t('cargo.confirmClearanceAction'));
							if (this.actionRejectClearance)
								this.$puiNotify.success(this.$puiI18n.t('puiaction.notifySuccess'), this.$puiI18n.t('cargo.actionRejectClearance'));
							if (this.actionUndoRejectClearance)
								this.$puiNotify.success(this.$puiI18n.t('puiaction.notifySuccess'), this.$t('cargo.undoRejectClearanceAction'));
							resolve(true);
							this.checkboxGroup.loading = false;
							this.checkboxGroup.unloading = false;
							this.$puiEvents.$emit('onPuiRouter-sameModelAndComponent-refreshRouter');
						},
						(e) => {
							let message = this.$puiI18n.t('puiaction.notifyError');
							if (e.response && e.response.data) {
								message = e.response.data.message;
							}
							if (this.actionClearance) this.$puiNotify.error(message, this.$puiI18n.t('cargo.requestClearanceAction', 0, true));
							if (this.actionRejectDoc) this.$puiNotify.error(message, this.$puiI18n.t('cargo.rejectDocumentationAction', 0, true));
							if (this.actionConfirmClearance) this.$puiNotify.error(message, this.$puiI18n.t('cargo.confirmClearanceAction', 0, true));
							if (this.actionRejectClearance) this.$puiNotify.error(message, this.$puiI18n.t('cargo.actionRejectClearance', 0, true));
							if (this.actionUndoRejectClearance) this.$puiNotify.error(message, this.$t('cargo.undoRejectClearanceAction', 0, true));
							resolve(false);
							this.checkboxGroup.loading = false;
							this.checkboxGroup.unloading = false;
							this.$puiEvents.$emit('onPuiRouter-sameModelAndComponent-refreshRouter');
						}
					);
				});
			}
		},
		disableCheckbox(modalData, actionNum) {
			this.checkboxGroup.loading = false;
			this.checkboxGroup.unloading = false;
			this.loadingDisabled = false;
			this.unloadingDisabled = false;

			let loading = modalData.registries.loadingstatus;
			let unloading = modalData.registries.unloadingstatus;

			if (actionNum == 1) {
				if (
					loading == 'Documentation ready' ||
					loading == 'Cleared' ||
					loading == 'Rejected' ||
					loading == 'Clearance requested' ||
					loading == 'დოკუმენტაცია მზად არის განსახილველად' ||
					loading == 'ნებართვა გაცემულია' ||
					loading == 'ნებართვა უარყოფილია' ||
					loading == 'მოთხოვნა ნებართვაზე გაგზავნილია'
				) {
					this.loadingDisabled = true;
				}
				if (
					unloading == 'Documentation ready' ||
					unloading == 'Cleared' ||
					unloading == 'Rejected' ||
					unloading == 'Clearance requested' ||
					unloading == 'დოკუმენტაცია მზად არის განსახილველად' ||
					unloading == 'ნებართვა გაცემულია' ||
					unloading == 'ნებართვა უარყოფილია' ||
					unloading == 'მოთხოვნა ნებართვაზე გაგზავნილია'
				) {
					this.unloadingDisabled = true;
				}
			}
			if (actionNum == 2 || actionNum == 3) {
				if (
					loading == 'Documentation pending' ||
					loading == 'Documentation ready' ||
					loading == 'Documentation rejected' ||
					loading == 'Cleared' ||
					loading == 'Rejected' ||
					loading == 'Partially cleared' ||
					loading == 'დოკუმენტაცია მოლოდინის რეჟიმშია' ||
					loading == 'დოკუმენტაცია მზად არის განსახილველად' ||
					loading == 'დოკუმენტაცია უარყოფილია' ||
					loading == 'ნებართვა გაცემულია' ||
					loading == 'ნებართვა უარყოფილია' ||
					loading == 'ნაწილობრივი ნებართვა გაცემულია'
				) {
					this.loadingDisabled = true;
				}
				if (
					unloading == 'Documentation pending' ||
					unloading == 'Documentation ready' ||
					unloading == 'Documentation rejected' ||
					unloading == 'Cleared' ||
					unloading == 'Rejected' ||
					unloading == 'Partially cleared' ||
					unloading == 'დოკუმენტაცია მოლოდინის რეჟიმშია' ||
					unloading == 'დოკუმენტაცია მზად არის განსახილველად' ||
					unloading == 'დოკუმენტაცია უარყოფილია' ||
					unloading == 'ნებართვა გაცემულია' ||
					unloading == 'ნებართვა უარყოფილია' ||
					unloading == 'ნაწილობრივი ნებართვა გაცემულია'
				) {
					this.unloadingDisabled = true;
				}
			}
			if (actionNum == 4) {
				if (loading == 'Rejected' || loading == 'ნებართვა უარყოფილია') {
					this.loadingDisabled = true;
				}
				if (unloading == 'Rejected' || unloading == 'ნებართვა უარყოფილია') {
					this.unloadingDisabled = true;
				}
			}
			if (actionNum == 5) {
				if (loading == 'Rejected' || loading == 'ნებართვა უარყოფილია') {
					this.checkboxGroup.loading = false;
					this.loadingDisabled = false;
				} else {
					this.checkboxGroup.loading = false;
					this.loadingDisabled = true;
				}

				if (unloading == 'Rejected' || unloading == 'ნებართვა უარყოფილია') {
					this.checkboxGroup.unloading = false;
					this.unloadingDisabled = false;
				} else {
					this.checkboxGroup.unloading = false;
					this.unloadingDisabled = true;
				}
			}
		},
		parsedAuditContent(record) {
			if (!record || !record.content) return [];
			if (typeof record.content === 'string') {
				try {
					return JSON.parse(record.content);
				} catch (e) {
					return [];
				}
			}
			console.log('parsedAuditContent- RECORD!!!', record);
			return Array.isArray(record.content) ? record.content : [];
		},
		formatDate(value) {
			if (!value) return '';
			return this.$dateTimeUtils.getLocalFormattedDate(value, `${this.$store.getters.dateFormat} ${this.$store.getters.timeFormat}`);
		},
		onSelectRecord(record) {
			if (this.selectedRecord && this.selectedRecord.id === record.id) {
				this.selectedRecord = null;
			} else {
				this.selectedRecord = record;
				console.log('RECORD SELECTED- RECORD!!!', this.selectedRecord);
			}
		},
		onAuditModalChange(val) {
			if (!val.showDialog) {
				this.selectedRecord = null;
				this.content = [];
			}
		}
	},
	watch: {
		selectedRecord(newVal) {
			if (!newVal) {
				this.content = [];
			} else {
				this.content = this.parsedAuditContent(newVal);
			}
		}
	}
};
</script>
<style lang="postcss">
.puiAuditFormtable {
	height: 600px;
	width: 100%;
	display: flex;
	gap: 20px;
}

/* Tabla principal */
.audit-grid {
	flex: 0 0 55%; /* ancho fijo 55% */
	min-width: 400px;
	overflow-y: auto;
}

.audit-grid table {
	width: 100%;
	border-collapse: collapse;
	overflow-y: auto;
}

.audit-grid th {
	background: #f9f9f9;
	font-weight: bold;
	border: none; /* sin líneas en cabecera */
	padding: 10px;
	text-align: left;
	white-space: nowrap; /* no cortar palabras */
}

.audit-grid td {
	border: none; /* sin líneas en celdas */
	padding: 10px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: keep-all;
}

/* Zebra striping en la tabla principal */
.audit-grid tbody tr:nth-child(even) {
	background-color: #ffffff;
}
.audit-grid tbody tr:nth-child(odd) {
	background-color: #e7eef2;
}

.audit-details {
	flex: 0 0 45%; /* ancho fijo 45% */
	min-width: 300px; /* asegura que se vea en pantallas pequeñas */
	overflow-y: auto;
	overflow-x: auto;
}

.selected {
	background-color: #2f6383 !important; /* azul más oscuro */
	color: #fff;
}
.audit-details table {
	width: 100%;
	table-layout: fixed; /* asegura que no se desborde */
	border-collapse: collapse;
}

.audit-details th,
.audit-details td {
	border: 1px solid #dddddd;
	padding: 8px 10px;
	text-align: left;
	word-break: keep-all;
	white-space: normal; /* permite saltos de línea */
}

.audit-details thead th {
	position: sticky;
	top: 0;
	background: #f9f9f9; /* para que se diferencie y tape las celdas al hacer scroll */
	z-index: 2; /* que quede por encima del contenido */
}
</style>

